module.exports = __webpack_public_path__ + "img/default.0412bb0d.png";